


import Vue from "vue";
import { Component, Prop, PropSync } from "vue-property-decorator";
import { BvModalEvent } from "bootstrap-vue";
import { LatLngBounds } from "leaflet";
import TicketsService from "@/services/TicketsService"

type VFormElement = Vue & { checkValidity: () => boolean }

@Component({
  name: "MapReportButton",
})
export default class ReportButton extends Vue {
  readonly icon: string = "favicon.ico";
  readonly osTicketURL = "";

  @Prop({ required: true }) source!: any | null;
  @PropSync("sourceBounds") syncedSourceBounds!: LatLngBounds | null;
  
  modalState: boolean;
  overlayState: boolean;

  nameState: boolean | null;
  emailState: boolean | null;
  subjectState: boolean | null;
  elementidState: boolean | null;
  boundsState: boolean | null;
  messageState: boolean | null;
  termsState: boolean | null;

  nameValue: string;
  emailValue: string;
  subjectValue: string;
  elementidValue: string;
  messageValue: string;
  imageValue: ImageBitmap | null;
  acceptTerms: boolean;
  // TODO several images

  public constructor() {
    super();
    this.modalState = false;
    this.overlayState = false;

    this.nameState = null;
    this.emailState = null;
    this.subjectState = null;
    this.elementidState = null;
    this.boundsState = null;
    this.messageState = null;
    this.termsState = null;

    this.nameValue = "";
    this.emailValue = "";
    this.subjectValue = "";
    this.elementidValue = this.source || "<null> General report"
    this.messageValue = "";
    this.imageValue = null;
    this.acceptTerms = false;
  }

  public submitForm(event: BvModalEvent): void {
    // Prevent modal from closing
    event.preventDefault();
    // Check validities
    this.nameState = (this.$refs.name as VFormElement).checkValidity();
    this.emailState = (this.$refs.email as VFormElement).checkValidity();
    this.subjectState = (this.$refs.subject as VFormElement).checkValidity();
    this.elementidState = (this.$refs.elementid as VFormElement).checkValidity();
    this.boundsState = (this.$refs.bounds as VFormElement).checkValidity();
    this.messageState = (this.$refs.message as VFormElement).checkValidity();
    this.termsState = this.acceptTerms;
    // Trigger submit handler
    if ((this.$refs.form as VFormElement).checkValidity() && this.termsState == true)
      this.sendReport();
  }

  public sendReport(): void {
    console.log("sending report...");

    const ticket = {
      "name": this.nameValue,
      "email": this.emailValue,
      "subject": this.subjectValue,
      "message": this.messageValue,
      "alert": false,
      "autorespond": false,
      "source": "data-visualizer",
      "attachments": [
        {"image.png": this.imageValue},
      ]
    };

    TicketsService.sendTicket(ticket)

    this.removeImage();
    this.modalState = false;
  }

  public showModal(show = true): void {
    this.modalState = show;
    this.elementidValue = this.source || "<null> General report"
  }

  public showOverlay(show: boolean | undefined): void {
    this.overlayState = show || !this.overlayState;
  }

  public removeImage(): void {
    this.showOverlay(false);
    this.imageValue = null;
  }

  /* Getters */

  public get boundsValue(): string {
    return this.syncedSourceBounds?.toBBoxString() || "<null> unknowing";
  }

  public get imageURL(): string {
    return URL.createObjectURL(this.imageValue);
  }

  /* Item events */

  public onClickReportButton = (): void => this.showModal(true);
  public onMouseoveroutImage = (hover: boolean): void => this.showOverlay(hover);
  public onClickCloseOverlay = (): void => this.removeImage();
  //public onShowModal = (event: BvModalEvent): void => {;};
  //public onHiddenModal = (event: BvModalEvent): void => {;};
  public onOkModal = (event: BvModalEvent): void => this.submitForm(event);

}
